import React, { Component } from "react";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "../DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import { RTRequest, RTRequestStatusId } from "@eres/rtregistrationapi/entities";
import { getRTReqDate, getRTReqProcedureType, getRTReqStatus, getRTReqTransactionNo } from "@my-dld/screens/MyDLD/MyRequest/RTRequests";

export interface RTReqProps {
	items: RTRequest[];
	isAnyPending?: boolean;
	onShowCancel: ( item: RTRequest ) => void;
}

class RTRequestsListView extends Component<RTReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items, isAnyPending } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader isAnyPending={ isAnyPending }/>;
			} }
			renderListItem={ ( item: RTRequest ) => {
				return <RenderListItem
					key={ "" + item.OnlineRequestId }
					item={ item }
					isAnyPending={ isAnyPending }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const showCancel = this.props.onShowCancel;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					showCancel( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader( props: { isAnyPending?: boolean } ) {
	const { isAnyPending } = props;
	return <tr>
		<th>{ Strings.transaction_number }</th>
		<th>{ Strings.procedure_type }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.submission_date }</th>
		{ isAnyPending && <th>{ " " }</th> }
	</tr>;
}

function RenderListItem( props: { item: RTRequest, isAnyPending?: boolean } ) {
	const { item, isAnyPending } = props;
	const isPending = ( item.OnlineRequestStatusId === RTRequestStatusId.PENDING );
	return <tr key={ item.OnlineRequestId }>
		<td data-label={ Strings.transaction_number }>{ getRTReqTransactionNo( item ) }</td>
		<td data-label={ Strings.procedure_type }>{ getRTReqProcedureType( item ) }</td>
		<td data-label={ Strings.status }>{ getRTReqStatus( item ) }</td>
		<td data-label={ Strings.submission_date }>{ getRTReqDate( item ) }</td>
		{ isAnyPending && <td>
			{ isPending && <a
				href="#"
				className="rt-request-cancel-link"
				data-item={ JSON.stringify( item ) }>
				<i className="far fa-times-circle"/><span>{ Strings.cancel }</span>
			</a> }
		</td> }
	</tr>;
}

export default RTRequestsListView;
